/* eslint-disable */
import _m0 from "protobufjs/minimal";
import { Status, statusFromJSON, statusToJSON } from "./constants";
import { WifiAuthMode, wifiAuthModeFromJSON, wifiAuthModeToJSON } from "./wifi_constants";

export const protobufPackage = "espressif";

export enum WiFiScanMsgType {
  TypeCmdScanStart = 0,
  TypeRespScanStart = 1,
  TypeCmdScanStatus = 2,
  TypeRespScanStatus = 3,
  TypeCmdScanResult = 4,
  TypeRespScanResult = 5,
  UNRECOGNIZED = -1,
}

export function wiFiScanMsgTypeFromJSON(object: any): WiFiScanMsgType {
  switch (object) {
    case 0:
    case "TypeCmdScanStart":
      return WiFiScanMsgType.TypeCmdScanStart;
    case 1:
    case "TypeRespScanStart":
      return WiFiScanMsgType.TypeRespScanStart;
    case 2:
    case "TypeCmdScanStatus":
      return WiFiScanMsgType.TypeCmdScanStatus;
    case 3:
    case "TypeRespScanStatus":
      return WiFiScanMsgType.TypeRespScanStatus;
    case 4:
    case "TypeCmdScanResult":
      return WiFiScanMsgType.TypeCmdScanResult;
    case 5:
    case "TypeRespScanResult":
      return WiFiScanMsgType.TypeRespScanResult;
    case -1:
    case "UNRECOGNIZED":
    default:
      return WiFiScanMsgType.UNRECOGNIZED;
  }
}

export function wiFiScanMsgTypeToJSON(object: WiFiScanMsgType): string {
  switch (object) {
    case WiFiScanMsgType.TypeCmdScanStart:
      return "TypeCmdScanStart";
    case WiFiScanMsgType.TypeRespScanStart:
      return "TypeRespScanStart";
    case WiFiScanMsgType.TypeCmdScanStatus:
      return "TypeCmdScanStatus";
    case WiFiScanMsgType.TypeRespScanStatus:
      return "TypeRespScanStatus";
    case WiFiScanMsgType.TypeCmdScanResult:
      return "TypeCmdScanResult";
    case WiFiScanMsgType.TypeRespScanResult:
      return "TypeRespScanResult";
    case WiFiScanMsgType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface CmdScanStart {
  blocking: boolean;
  passive: boolean;
  groupChannels: number;
  periodMs: number;
}

export interface RespScanStart {
}

export interface CmdScanStatus {
}

export interface RespScanStatus {
  scanFinished: boolean;
  resultCount: number;
}

export interface CmdScanResult {
  startIndex: number;
  count: number;
}

export interface WiFiScanResult {
  ssid: Uint8Array;
  channel: number;
  rssi: number;
  bssid: Uint8Array;
  auth: WifiAuthMode;
}

export interface RespScanResult {
  entries: WiFiScanResult[];
}

export interface WiFiScanPayload {
  msg: WiFiScanMsgType;
  status: Status;
  cmdScanStart?: CmdScanStart | undefined;
  respScanStart?: RespScanStart | undefined;
  cmdScanStatus?: CmdScanStatus | undefined;
  respScanStatus?: RespScanStatus | undefined;
  cmdScanResult?: CmdScanResult | undefined;
  respScanResult?: RespScanResult | undefined;
}

function createBaseCmdScanStart(): CmdScanStart {
  return { blocking: false, passive: false, groupChannels: 0, periodMs: 0 };
}

export const CmdScanStart = {
  encode(message: CmdScanStart, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.blocking === true) {
      writer.uint32(8).bool(message.blocking);
    }
    if (message.passive === true) {
      writer.uint32(16).bool(message.passive);
    }
    if (message.groupChannels !== 0) {
      writer.uint32(24).uint32(message.groupChannels);
    }
    if (message.periodMs !== 0) {
      writer.uint32(32).uint32(message.periodMs);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): CmdScanStart {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCmdScanStart();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.blocking = reader.bool();
          break;
        case 2:
          message.passive = reader.bool();
          break;
        case 3:
          message.groupChannels = reader.uint32();
          break;
        case 4:
          message.periodMs = reader.uint32();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): CmdScanStart {
    return {
      blocking: isSet(object.blocking) ? Boolean(object.blocking) : false,
      passive: isSet(object.passive) ? Boolean(object.passive) : false,
      groupChannels: isSet(object.groupChannels) ? Number(object.groupChannels) : 0,
      periodMs: isSet(object.periodMs) ? Number(object.periodMs) : 0,
    };
  },

  toJSON(message: CmdScanStart): unknown {
    const obj: any = {};
    message.blocking !== undefined && (obj.blocking = message.blocking);
    message.passive !== undefined && (obj.passive = message.passive);
    message.groupChannels !== undefined && (obj.groupChannels = Math.round(message.groupChannels));
    message.periodMs !== undefined && (obj.periodMs = Math.round(message.periodMs));
    return obj;
  },

  create<I extends Exact<DeepPartial<CmdScanStart>, I>>(base?: I): CmdScanStart {
    return CmdScanStart.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<CmdScanStart>, I>>(object: I): CmdScanStart {
    const message = createBaseCmdScanStart();
    message.blocking = object.blocking ?? false;
    message.passive = object.passive ?? false;
    message.groupChannels = object.groupChannels ?? 0;
    message.periodMs = object.periodMs ?? 0;
    return message;
  },
};

function createBaseRespScanStart(): RespScanStart {
  return {};
}

export const RespScanStart = {
  encode(_: RespScanStart, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): RespScanStart {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRespScanStart();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(_: any): RespScanStart {
    return {};
  },

  toJSON(_: RespScanStart): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<RespScanStart>, I>>(base?: I): RespScanStart {
    return RespScanStart.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<RespScanStart>, I>>(_: I): RespScanStart {
    const message = createBaseRespScanStart();
    return message;
  },
};

function createBaseCmdScanStatus(): CmdScanStatus {
  return {};
}

export const CmdScanStatus = {
  encode(_: CmdScanStatus, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): CmdScanStatus {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCmdScanStatus();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(_: any): CmdScanStatus {
    return {};
  },

  toJSON(_: CmdScanStatus): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<CmdScanStatus>, I>>(base?: I): CmdScanStatus {
    return CmdScanStatus.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<CmdScanStatus>, I>>(_: I): CmdScanStatus {
    const message = createBaseCmdScanStatus();
    return message;
  },
};

function createBaseRespScanStatus(): RespScanStatus {
  return { scanFinished: false, resultCount: 0 };
}

export const RespScanStatus = {
  encode(message: RespScanStatus, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.scanFinished === true) {
      writer.uint32(8).bool(message.scanFinished);
    }
    if (message.resultCount !== 0) {
      writer.uint32(16).uint32(message.resultCount);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): RespScanStatus {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRespScanStatus();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.scanFinished = reader.bool();
          break;
        case 2:
          message.resultCount = reader.uint32();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): RespScanStatus {
    return {
      scanFinished: isSet(object.scanFinished) ? Boolean(object.scanFinished) : false,
      resultCount: isSet(object.resultCount) ? Number(object.resultCount) : 0,
    };
  },

  toJSON(message: RespScanStatus): unknown {
    const obj: any = {};
    message.scanFinished !== undefined && (obj.scanFinished = message.scanFinished);
    message.resultCount !== undefined && (obj.resultCount = Math.round(message.resultCount));
    return obj;
  },

  create<I extends Exact<DeepPartial<RespScanStatus>, I>>(base?: I): RespScanStatus {
    return RespScanStatus.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<RespScanStatus>, I>>(object: I): RespScanStatus {
    const message = createBaseRespScanStatus();
    message.scanFinished = object.scanFinished ?? false;
    message.resultCount = object.resultCount ?? 0;
    return message;
  },
};

function createBaseCmdScanResult(): CmdScanResult {
  return { startIndex: 0, count: 0 };
}

export const CmdScanResult = {
  encode(message: CmdScanResult, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.startIndex !== 0) {
      writer.uint32(8).uint32(message.startIndex);
    }
    if (message.count !== 0) {
      writer.uint32(16).uint32(message.count);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): CmdScanResult {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCmdScanResult();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.startIndex = reader.uint32();
          break;
        case 2:
          message.count = reader.uint32();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): CmdScanResult {
    return {
      startIndex: isSet(object.startIndex) ? Number(object.startIndex) : 0,
      count: isSet(object.count) ? Number(object.count) : 0,
    };
  },

  toJSON(message: CmdScanResult): unknown {
    const obj: any = {};
    message.startIndex !== undefined && (obj.startIndex = Math.round(message.startIndex));
    message.count !== undefined && (obj.count = Math.round(message.count));
    return obj;
  },

  create<I extends Exact<DeepPartial<CmdScanResult>, I>>(base?: I): CmdScanResult {
    return CmdScanResult.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<CmdScanResult>, I>>(object: I): CmdScanResult {
    const message = createBaseCmdScanResult();
    message.startIndex = object.startIndex ?? 0;
    message.count = object.count ?? 0;
    return message;
  },
};

function createBaseWiFiScanResult(): WiFiScanResult {
  return { ssid: new Uint8Array(), channel: 0, rssi: 0, bssid: new Uint8Array(), auth: 0 };
}

export const WiFiScanResult = {
  encode(message: WiFiScanResult, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.ssid.length !== 0) {
      writer.uint32(10).bytes(message.ssid);
    }
    if (message.channel !== 0) {
      writer.uint32(16).uint32(message.channel);
    }
    if (message.rssi !== 0) {
      writer.uint32(24).int32(message.rssi);
    }
    if (message.bssid.length !== 0) {
      writer.uint32(34).bytes(message.bssid);
    }
    if (message.auth !== 0) {
      writer.uint32(40).int32(message.auth);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): WiFiScanResult {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWiFiScanResult();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.ssid = reader.bytes();
          break;
        case 2:
          message.channel = reader.uint32();
          break;
        case 3:
          message.rssi = reader.int32();
          break;
        case 4:
          message.bssid = reader.bytes();
          break;
        case 5:
          message.auth = reader.int32() as any;
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): WiFiScanResult {
    return {
      ssid: isSet(object.ssid) ? bytesFromBase64(object.ssid) : new Uint8Array(),
      channel: isSet(object.channel) ? Number(object.channel) : 0,
      rssi: isSet(object.rssi) ? Number(object.rssi) : 0,
      bssid: isSet(object.bssid) ? bytesFromBase64(object.bssid) : new Uint8Array(),
      auth: isSet(object.auth) ? wifiAuthModeFromJSON(object.auth) : 0,
    };
  },

  toJSON(message: WiFiScanResult): unknown {
    const obj: any = {};
    message.ssid !== undefined &&
      (obj.ssid = base64FromBytes(message.ssid !== undefined ? message.ssid : new Uint8Array()));
    message.channel !== undefined && (obj.channel = Math.round(message.channel));
    message.rssi !== undefined && (obj.rssi = Math.round(message.rssi));
    message.bssid !== undefined &&
      (obj.bssid = base64FromBytes(message.bssid !== undefined ? message.bssid : new Uint8Array()));
    message.auth !== undefined && (obj.auth = wifiAuthModeToJSON(message.auth));
    return obj;
  },

  create<I extends Exact<DeepPartial<WiFiScanResult>, I>>(base?: I): WiFiScanResult {
    return WiFiScanResult.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<WiFiScanResult>, I>>(object: I): WiFiScanResult {
    const message = createBaseWiFiScanResult();
    message.ssid = object.ssid ?? new Uint8Array();
    message.channel = object.channel ?? 0;
    message.rssi = object.rssi ?? 0;
    message.bssid = object.bssid ?? new Uint8Array();
    message.auth = object.auth ?? 0;
    return message;
  },
};

function createBaseRespScanResult(): RespScanResult {
  return { entries: [] };
}

export const RespScanResult = {
  encode(message: RespScanResult, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.entries) {
      WiFiScanResult.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): RespScanResult {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRespScanResult();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.entries.push(WiFiScanResult.decode(reader, reader.uint32()));
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): RespScanResult {
    return {
      entries: Array.isArray(object?.entries) ? object.entries.map((e: any) => WiFiScanResult.fromJSON(e)) : [],
    };
  },

  toJSON(message: RespScanResult): unknown {
    const obj: any = {};
    if (message.entries) {
      obj.entries = message.entries.map((e) => e ? WiFiScanResult.toJSON(e) : undefined);
    } else {
      obj.entries = [];
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RespScanResult>, I>>(base?: I): RespScanResult {
    return RespScanResult.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<RespScanResult>, I>>(object: I): RespScanResult {
    const message = createBaseRespScanResult();
    message.entries = object.entries?.map((e) => WiFiScanResult.fromPartial(e)) || [];
    return message;
  },
};

function createBaseWiFiScanPayload(): WiFiScanPayload {
  return {
    msg: 0,
    status: 0,
    cmdScanStart: undefined,
    respScanStart: undefined,
    cmdScanStatus: undefined,
    respScanStatus: undefined,
    cmdScanResult: undefined,
    respScanResult: undefined,
  };
}

export const WiFiScanPayload = {
  encode(message: WiFiScanPayload, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.msg !== 0) {
      writer.uint32(8).int32(message.msg);
    }
    if (message.status !== 0) {
      writer.uint32(16).int32(message.status);
    }
    if (message.cmdScanStart !== undefined) {
      CmdScanStart.encode(message.cmdScanStart, writer.uint32(82).fork()).ldelim();
    }
    if (message.respScanStart !== undefined) {
      RespScanStart.encode(message.respScanStart, writer.uint32(90).fork()).ldelim();
    }
    if (message.cmdScanStatus !== undefined) {
      CmdScanStatus.encode(message.cmdScanStatus, writer.uint32(98).fork()).ldelim();
    }
    if (message.respScanStatus !== undefined) {
      RespScanStatus.encode(message.respScanStatus, writer.uint32(106).fork()).ldelim();
    }
    if (message.cmdScanResult !== undefined) {
      CmdScanResult.encode(message.cmdScanResult, writer.uint32(114).fork()).ldelim();
    }
    if (message.respScanResult !== undefined) {
      RespScanResult.encode(message.respScanResult, writer.uint32(122).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): WiFiScanPayload {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWiFiScanPayload();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.msg = reader.int32() as any;
          break;
        case 2:
          message.status = reader.int32() as any;
          break;
        case 10:
          message.cmdScanStart = CmdScanStart.decode(reader, reader.uint32());
          break;
        case 11:
          message.respScanStart = RespScanStart.decode(reader, reader.uint32());
          break;
        case 12:
          message.cmdScanStatus = CmdScanStatus.decode(reader, reader.uint32());
          break;
        case 13:
          message.respScanStatus = RespScanStatus.decode(reader, reader.uint32());
          break;
        case 14:
          message.cmdScanResult = CmdScanResult.decode(reader, reader.uint32());
          break;
        case 15:
          message.respScanResult = RespScanResult.decode(reader, reader.uint32());
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): WiFiScanPayload {
    return {
      msg: isSet(object.msg) ? wiFiScanMsgTypeFromJSON(object.msg) : 0,
      status: isSet(object.status) ? statusFromJSON(object.status) : 0,
      cmdScanStart: isSet(object.cmdScanStart) ? CmdScanStart.fromJSON(object.cmdScanStart) : undefined,
      respScanStart: isSet(object.respScanStart) ? RespScanStart.fromJSON(object.respScanStart) : undefined,
      cmdScanStatus: isSet(object.cmdScanStatus) ? CmdScanStatus.fromJSON(object.cmdScanStatus) : undefined,
      respScanStatus: isSet(object.respScanStatus) ? RespScanStatus.fromJSON(object.respScanStatus) : undefined,
      cmdScanResult: isSet(object.cmdScanResult) ? CmdScanResult.fromJSON(object.cmdScanResult) : undefined,
      respScanResult: isSet(object.respScanResult) ? RespScanResult.fromJSON(object.respScanResult) : undefined,
    };
  },

  toJSON(message: WiFiScanPayload): unknown {
    const obj: any = {};
    message.msg !== undefined && (obj.msg = wiFiScanMsgTypeToJSON(message.msg));
    message.status !== undefined && (obj.status = statusToJSON(message.status));
    message.cmdScanStart !== undefined &&
      (obj.cmdScanStart = message.cmdScanStart ? CmdScanStart.toJSON(message.cmdScanStart) : undefined);
    message.respScanStart !== undefined &&
      (obj.respScanStart = message.respScanStart ? RespScanStart.toJSON(message.respScanStart) : undefined);
    message.cmdScanStatus !== undefined &&
      (obj.cmdScanStatus = message.cmdScanStatus ? CmdScanStatus.toJSON(message.cmdScanStatus) : undefined);
    message.respScanStatus !== undefined &&
      (obj.respScanStatus = message.respScanStatus ? RespScanStatus.toJSON(message.respScanStatus) : undefined);
    message.cmdScanResult !== undefined &&
      (obj.cmdScanResult = message.cmdScanResult ? CmdScanResult.toJSON(message.cmdScanResult) : undefined);
    message.respScanResult !== undefined &&
      (obj.respScanResult = message.respScanResult ? RespScanResult.toJSON(message.respScanResult) : undefined);
    return obj;
  },

  create<I extends Exact<DeepPartial<WiFiScanPayload>, I>>(base?: I): WiFiScanPayload {
    return WiFiScanPayload.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<WiFiScanPayload>, I>>(object: I): WiFiScanPayload {
    const message = createBaseWiFiScanPayload();
    message.msg = object.msg ?? 0;
    message.status = object.status ?? 0;
    message.cmdScanStart = (object.cmdScanStart !== undefined && object.cmdScanStart !== null)
      ? CmdScanStart.fromPartial(object.cmdScanStart)
      : undefined;
    message.respScanStart = (object.respScanStart !== undefined && object.respScanStart !== null)
      ? RespScanStart.fromPartial(object.respScanStart)
      : undefined;
    message.cmdScanStatus = (object.cmdScanStatus !== undefined && object.cmdScanStatus !== null)
      ? CmdScanStatus.fromPartial(object.cmdScanStatus)
      : undefined;
    message.respScanStatus = (object.respScanStatus !== undefined && object.respScanStatus !== null)
      ? RespScanStatus.fromPartial(object.respScanStatus)
      : undefined;
    message.cmdScanResult = (object.cmdScanResult !== undefined && object.cmdScanResult !== null)
      ? CmdScanResult.fromPartial(object.cmdScanResult)
      : undefined;
    message.respScanResult = (object.respScanResult !== undefined && object.respScanResult !== null)
      ? RespScanResult.fromPartial(object.respScanResult)
      : undefined;
    return message;
  },
};

declare var self: any | undefined;
declare var window: any | undefined;
declare var global: any | undefined;
var tsProtoGlobalThis: any = (() => {
  if (typeof globalThis !== "undefined") {
    return globalThis;
  }
  if (typeof self !== "undefined") {
    return self;
  }
  if (typeof window !== "undefined") {
    return window;
  }
  if (typeof global !== "undefined") {
    return global;
  }
  throw "Unable to locate global object";
})();

function bytesFromBase64(b64: string): Uint8Array {
  if (tsProtoGlobalThis.Buffer) {
    return Uint8Array.from(tsProtoGlobalThis.Buffer.from(b64, "base64"));
  } else {
    const bin = tsProtoGlobalThis.atob(b64);
    const arr = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; ++i) {
      arr[i] = bin.charCodeAt(i);
    }
    return arr;
  }
}

function base64FromBytes(arr: Uint8Array): string {
  if (tsProtoGlobalThis.Buffer) {
    return tsProtoGlobalThis.Buffer.from(arr).toString("base64");
  } else {
    const bin: string[] = [];
    arr.forEach((byte) => {
      bin.push(String.fromCharCode(byte));
    });
    return tsProtoGlobalThis.btoa(bin.join(""));
  }
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Array<infer U> ? Array<DeepPartial<U>> : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
